export default {
  "pl": {
    "issue_list": {
      "actions": {
        "add_units": "Dodaj jednostki",
        "all_units_assigned": "Wszystkie przypisane jednostki",
        "create_issue_lists": "Utwórz listę problemów | Utwórz listy problemów",
        "delete": "Usuń...",
        "delete_count": "Zamierzasz usunąć problemy dla {count} jednostki. Czy na pewno? | Zamierzasz usunąć problemy dla {count} jednostek. Czy na pewno?",
        "delete_issue_lists": "Usuń problemy",
        "edit": "Edytuj",
        "edit_issue_list": "Edytuj typ listy problemów",
        "go_to_summary": "Przejdź do podsumowania",
        "new": "Nowy problem",
        "new_issue_list": "Nowa lista problemów",
        "update": "Aktualizuj"
      },
      "attributes": {
        "date": "Data rozpoczęcia",
        "description": "Opis",
        "name": "Nazwa"
      },
      "labels": {
        "completed_header": "zakończono {completed_count} z {issues_count} problemów",
        "customer": "Klient",
        "date": "Data rozpoczęcia (opcjonalnie)",
        "delete_explanation": "Wszystkie problemy wraz z ich obrazami i dokumentami trwale usuniętymi z platformy.",
        "description_title": "Dodaj opis",
        "hide_count": "Cofnij publikację numerów 1 jednostki | Cofnij publikację numerów {count} jednostek",
        "issue_list": "Lista problemów",
        "issue_lists": "Listy problemów",
        "no_lists_completed": "Brak ukończonych list",
        "partners": "Partnerzy",
        "project_units_total": "{project_name} ma łącznie {units_count_max} jednostek",
        "publish_now": "Opublikuj teraz?",
        "published_count": "Publikuj numery dla 1 jednostki | Publikuj numery dla {count} jednostek",
        "save_explainer": "Uwidocznić (przyszłe) problemy swoim klientom? Albo zapisać i opublikować później?",
        "status": "status",
        "step_1_info": "Np. dostawa wstępna lub końcowa, problemy z kuchnią lub łazienką,...",
        "step_1_title": "Jakiego typu listę problemów chcesz utworzyć?",
        "step_2_subtitle": "Wybierz swój projekt, aby uwzględnić wszystkie jednostki naraz. Zawsze możesz dodać więcej jednostek później.",
        "step_2_title": "Dla których jednostek chcesz rejestrować problemy?",
        "tab_issue_list_documents": "Dokumenty",
        "tab_issue_list_issues": "Problemy",
        "tab_issue_list_tickets": "Rozmowy",
        "tab_issues": "Wszystkie problemy",
        "tab_units": "Jednostki"
      },
      "navigation": {
        "back_to_issue_lists": "Powrót do list problemów"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Utwórz sprawy dla jednostek dołączonych do listy",
            "title": "Utwórz swoją pierwszą listę problemów"
          }
        },
        "partners": {
          "subtitle": "Otrzymasz powiadomienie, gdy pojawią się nowe problemy",
          "title": "Nie przypisano Ci jeszcze żadnych problemów"
        }
      },
      "validation": {
        "name_already_taken": "Nazwa tego projektu jest już zajęta.",
        "need_name": "Nazwa jest wymagana"
      }
    }
  }
}
